/*
 * <gs-header-megamenu> — category tabs (horizontal row) swapping the links + featured
 * product zones, and keeping the mobile sheet's featured cards in sync.
 * Markup: snippets/gs-header-megamenu.liquid. Docs: docs/gs-header-architecture.md.
 */
if (!customElements.get('gs-header-megamenu')) {
  class GSHeaderMegamenu extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"][data-gs-mega-cat]'));
      this.panes = Array.from(this.querySelectorAll('[data-gs-mega-pane]'));
      this._onClick = (e) => {
        const tab = e.target.closest('[data-gs-mega-cat]');
        if (tab) this.select(tab.dataset.gsMegaCat);
      };
      this._onOver = (e) => {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        const tab = e.target.closest('[data-gs-mega-cat]');
        if (tab && !tab.classList.contains('is-active')) this.select(tab.dataset.gsMegaCat);
      };
      this._onKey = (e) => this._keydown(e);
      this._onHeaderOpen = (e) => {
        if (e.detail && e.detail.panel === 'mega') this.select(this._activeId() || (this.tabs[0] && this.tabs[0].dataset.gsMegaCat), { silent: true });
      };
      this._onMobileCat = (e) => this._syncMobile(e.detail && e.detail.id);
      this.addEventListener('click', this._onClick);
      this.addEventListener('pointerover', this._onOver);
      this.addEventListener('keydown', this._onKey);
      this.header = this.closest('gs-header');
      if (this.header) this.header.addEventListener('gs-header:mobile-category', this._onMobileCat);
      // Initial mobile featured state (first category is active by default).
      const first = this.header && this.header.querySelector('[data-gs-mobile-cat].is-active');
      this._syncMobile(first && first.dataset.gsMobileCat);
    }

    disconnectedCallback() {
      this._ready = false;
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('pointerover', this._onOver);
      this.removeEventListener('keydown', this._onKey);
      if (this.header) this.header.removeEventListener('gs-header:mobile-category', this._onMobileCat);
    }

    _activeId() {
      const t = this.tabs.find((x) => x.classList.contains('is-active'));
      return t && t.dataset.gsMegaCat;
    }

    select(id, { focus = false } = {}) {
      if (!id) return;
      this.tabs.forEach((t) => {
        const on = t.dataset.gsMegaCat === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      this.panes.forEach((p) => {
        p.hidden = p.dataset.gsMegaPane !== id;
      });
    }

    _keydown(e) {
      const tab = e.target.closest('[role="tab"]');
      if (!tab) return;
      const i = this.tabs.indexOf(tab);
      const n = this.tabs.length;
      let next = null;
      switch (e.key) {
        case 'ArrowRight': next = i + 1; break;
        case 'ArrowLeft': next = i - 1; break;
        case 'ArrowDown': next = i + 1; break;
        case 'ArrowUp': next = i - 1; break;
        case 'Home': next = 0; break;
        case 'End': next = n - 1; break;
        default: return;
      }
      if (next < 0 || next >= n) return;
      e.preventDefault();
      this.select(this.tabs[next].dataset.gsMegaCat, { focus: true });
    }

    _syncMobile(id) {
      if (!this.header) return;
      this.header.querySelectorAll('[data-gs-mobile-featured-for]').forEach((el) => {
        el.hidden = el.dataset.gsMobileFeaturedFor !== id;
      });
    }
  }
  customElements.define('gs-header-megamenu', GSHeaderMegamenu);
}
